import { useCallback, useState } from 'react';

export type IdeType = 'vscode' | 'cursor' | 'antigravity';

const BEEHIVE_URL_SUFFIX = 'beehive.beehive-contribute';

const IDE_URL_SCHEMES: Record<IdeType, string> = {
    vscode: `vscode://${BEEHIVE_URL_SUFFIX}`,
    cursor: `cursor://${BEEHIVE_URL_SUFFIX}`,
    antigravity: `antigravity://${BEEHIVE_URL_SUFFIX}`
};

interface UseIdeLauncherReturn {
    anchorEl: HTMLElement | null;
    launchIde: (ide: IdeType) => void;
    openMenu: (event: React.MouseEvent<HTMLElement>) => void;
    closeMenu: () => void;
}

export const useIdeLauncher = (workToken: string | null): UseIdeLauncherReturn => {
    const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);

    const launchIde = useCallback((ide: IdeType) => {
        if (workToken) {
            const ideUrl = `${IDE_URL_SCHEMES[ide]}?jwt=${workToken}`;
            window.location.href = ideUrl;
        }
        setAnchorEl(null);
    }, [ workToken ]);

    const openMenu = useCallback((event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const closeMenu = useCallback(() => {
        setAnchorEl(null);
    }, []);

    return {
        anchorEl,
        launchIde,
        openMenu,
        closeMenu
    };
};
